module.exports = __webpack_public_path__ + "static/img/case.49cac8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/case.png
// module id = U1Ph
// module chunks = 13